import { Polygon } from "geojson";
import { SiteReportUtilitySteps } from "../../../react-migration/domains/sites/typings/SiteUtilityReport";
import { proxy } from "valtio/vanilla";

type SiteId = string;

export enum ScopeType {
  ON_SITE = "onSite",
  NEARBY = "nearby",
}

export interface LayerScopeConfig {
  scopeType: ScopeType;
  radius?: number; // in meters
}

export interface SiteReportConfiguration {
  /** A list of planning applications a user wants excluded from the report. */
  excludePlanningApplicationIds?: string[];

  /** A list of comparable records a user wants excluded from the report. */
  excludeComparableIds?: string[];

  /** A list of demographics sections a user wants excluded from the report. */
  excludeDemographicsSectionIds?: string[];

  /** The region ID to compare demographics against in the report. */
  demographicsComparisonRegionId?: string;

  /** Path-based checkbox states for hierarchical checkbox management. */
  checkboxPaths?: Record<string, boolean>;

  layerScopes?: Record<string, LayerScopeConfig>;
}

type SiteReportConfigurationStore = Record<SiteId, SiteReportConfiguration>;

export type SiteStore = {
  selectedWorkspaceId: string | null;
  /** The Ids of sites currently selected in the sites pipeline */
  selectedSiteIds: SiteId[];
  siteCardId: string | null;
  siteReportConfiguration: SiteReportConfigurationStore;
  activeSiteReportUtilityStep: SiteReportUtilitySteps;
  utilityGeometry?: Polygon;
  dashboardTopUpRedirectUrl?: string;
};

const urlParams = new URLSearchParams(window.location.search);
const siteId = urlParams.get("site_id");

const siteReportConfiguration: SiteReportConfigurationStore = {};

export const siteStore = proxy<SiteStore>({
  selectedWorkspaceId: null,
  selectedSiteIds: [],
  siteReportConfiguration,
  siteCardId: siteId ?? null,
  activeSiteReportUtilityStep: SiteReportUtilitySteps.Overview,
});

export const localStorageKey = "siteReportConfiguration";
